module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-F"
  }, [_c('div', {
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "seekArea"
  }, [_c('div', {
    staticClass: "selectBox"
  }, [_c('span', [_vm._v("资质：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.selType),
      callback: function($$v) {
        _vm.selType = $$v
      },
      expression: "selType"
    }
  }, _vm._l((_vm.Zizhi), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "selectBox"
  }, [_c('span', [_vm._v("省局：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.selProvinceId),
      callback: function($$v) {
        _vm.selProvinceId = $$v
      },
      expression: "selProvinceId"
    }
  }, _vm._l((_vm.Shengju), function(item) {
    return _c('el-option', {
      key: item.sjExamineId,
      attrs: {
        "label": item.sjExamine,
        "value": item.sjExamineId
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "selectBox"
  }, [_c('span', [_vm._v("年份：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "size": "small",
      "placeholder": "历年记录"
    },
    model: {
      value: (_vm.selYear),
      callback: function($$v) {
        _vm.selYear = $$v
      },
      expression: "selYear"
    }
  }, _vm._l((_vm.selYearRecord), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "selectBox"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.goSeek
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "size": "small",
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.goExport
    }
  }, [_vm._v("导出")])], 1)]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDats,
      "border": "",
      "height": this.tableHeight
    },
    on: {
      "sort-change": this.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "min-width": "100",
      "align": "center",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "provinceName",
      "label": "所属省局",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "workers",
      "label": "单位职工总数",
      "align": "center",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "businessWorkers",
      "label": "从事电子出版物业务人员数",
      "width": "230",
      "align": "center",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "otherWorkers",
      "label": "其他人员数",
      "align": "center",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "leaderWorkers",
      "label": "领导班子人员数",
      "align": "center",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "leaderWorkerProportion",
      "label": "领导班子持证上岗率",
      "align": "center",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "zjCertificateWorkers",
      "label": "出版专业中级职称及以上人数",
      "width": "144",
      "align": "center",
      "sortable": "custom"
    }
  })], 1), _vm._v(" "), (_vm.params.pgAll > 1) ? _c('div', {
    staticClass: "pageCage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.params.no,
      "layout": "prev, pager, next",
      "page-count": _vm.params.pgAll
    },
    on: {
      "current-change": _vm.pageSent
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bce7a17c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/adminRole/adminPersonOperation.vue
// module id = 1794
// module chunks = 1